/* nano Reviews (Design A3): Reiter, Themen-Chips, Sterne-Filter, Mehr laden, Lightbox. Kein Framework. */
(function () {
  'use strict';

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function init(root) {
    if (!root || root.dataset.nrReady) return;
    root.dataset.nrReady = '1';

    var group = root.dataset.nrGroup;
    var fetchBase = root.dataset.nrFetch;
    var list = root.querySelector('[data-nr-list]');
    var more = root.querySelector('[data-nr-more]');
    var moreLabel = root.querySelector('[data-nr-more-label]');
    var status = root.querySelector('[data-nr-status]');
    var tabs = root.querySelectorAll('[data-nr-tab]');
    var state = { series: 'date', tab: 'date', filterLabel: '', filterSeries: '', page: 1, pageCount: 1, total: 0, shown: 0 };
    if (!list) return;

    function readInfo() {
      var infos = list.querySelectorAll('[data-nr-page-info]');
      var info = infos[infos.length - 1];
      if (info) {
        state.page = parseInt(info.dataset.page || '0', 10);
        state.pageCount = parseInt(info.dataset.pageCount || '0', 10);
        state.total = parseInt(info.dataset.total || '0', 10);
      }
      state.shown = list.querySelectorAll('.nr3-card').length;
      root.querySelectorAll('[data-nr-series]').forEach(function (b) { b.setAttribute('aria-pressed', state.filterSeries && b.dataset.nrSeries === state.filterSeries ? 'true' : 'false'); });
      if (more) {
        more.hidden = !(state.page < state.pageCount);
        var rest = Math.max(state.total - state.shown, 0);
        if (moreLabel) moreLabel.textContent = 'Weitere ' + Math.min(12, rest) + ' von ' + fmt(state.total) + ' laden';
      }
      if (status) {
        if (state.filterLabel) {
          status.hidden = false;
          status.innerHTML = '';
          var txt = document.createElement('span');
          txt.textContent = fmt(state.total) + (state.total === 1 ? ' Bewertung ' : ' Bewertungen ') + state.filterLabel;
          var reset = document.createElement('button');
          reset.type = 'button'; reset.className = 'nr3__reset'; reset.textContent = 'Filter aufheben';
          reset.addEventListener('click', function () { clearFilters(); load(state.tab, 1, true); });
          status.appendChild(txt); status.appendChild(reset);
        } else { status.hidden = true; }
      }
    }

    function load(series, page, replace) {
      var handle = group + '--' + series + '--' + page;
      if (more) more.classList.add('is-loading');
      if (replace) list.classList.add('is-loading');
      return fetch(fetchBase + encodeURIComponent(handle), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || html.indexOf('data-nr-page-info') === -1) return;
          if (replace) { list.innerHTML = html; }
          else {
            list.querySelectorAll('[data-nr-page-info]').forEach(function (n) { n.remove(); });
            list.insertAdjacentHTML('beforeend', html);
          }
          state.series = series;
          readInfo();
        })
        .catch(function () { /* alte Liste bleibt stehen */ })
        .then(function () { if (more) more.classList.remove('is-loading'); list.classList.remove('is-loading'); });
    }

    function clearFilters() {
      root.querySelectorAll('[data-nr-series]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      state.filterLabel = ''; state.filterSeries = '';
    }
    function selectTab(name) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.nrTab === name ? 'true' : 'false'); });
      state.tab = name;
    }

    if (more) more.addEventListener('click', function () { load(state.series, state.page + 1, false); });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { clearFilters(); selectTab(t.dataset.nrTab); load(t.dataset.nrTab, 1, true); });
    });

    /* Themen-, Alters- und Sterne-Filter (auch die Alters-Chips in nachgeladenen Karten): ein Filter aktiv, zweiter Klick hebt auf */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nr-series]');
      if (!btn || btn.disabled) return;
      var series = btn.dataset.nrSeries;
      var wasOn = state.filterSeries === series;
      var inCard = !!btn.closest('.nr3-card');
      clearFilters();
      if (wasOn) { load(state.tab, 1, true); return; }
      state.filterSeries = series;
      var rowChip = root.querySelector('.nr3__chips [data-nr-series="' + series + '"]');
      if (rowChip) btn = rowChip; /* Chip in der Karte: Beschriftung der Filterreihe übernehmen (mit Ø) */
      state.filterLabel = btn.dataset.nrTopic ? 'zu \u201E' + btn.dataset.nrTopic + '\u201C' : (btn.dataset.nrPhrase || '');
      load(series, 1, true).then(function () {
        if (inCard || window.matchMedia('(max-width: 860px)').matches) {
          var anchor = status && !status.hidden ? status : list;
          var y = anchor.getBoundingClientRect().top + window.pageYOffset - 150;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });

    /* Lightbox */
    var box = root.querySelector('[data-nr-lightbox]');
    var content = root.querySelector('[data-nr-lightbox-content]');
    var lastFocus = null;
    function closeBox() { if (!box) return; box.hidden = true; content.innerHTML = ''; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    root.addEventListener('click', function (e) {
      var item = e.target.closest('[data-nr-media]');
      if (!item || !box) return;
      lastFocus = item;
      var el = document.createElement(item.dataset.nrMediaType === 'video' ? 'video' : 'img');
      el.src = item.dataset.nrMedia;
      if (el.tagName === 'VIDEO') { el.controls = true; el.autoplay = true; el.playsInline = true; } else { el.alt = ''; }
      content.innerHTML = ''; content.appendChild(el);
      box.hidden = false; document.body.style.overflow = 'hidden';
      var c = box.querySelector('[data-nr-lightbox-close]'); if (c) c.focus();
    });
    if (box) {
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-nr-lightbox-close]')) closeBox(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeBox(); });
    }

    readInfo();
  }

  function boot() { document.querySelectorAll('[data-section-type="nano-reviews"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-section-type="nano-reviews"]')); });

  /* Sterne unter dem Titel: Klick scrollt zum Widget */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-nr-scroll]');
    if (!s) return;
    var target = document.getElementById('nano-reviews');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
